import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';

import { CarouselModule } from 'primeng/carousel';
import { CardEventComponent } from '../card-event/card-event.component';
import { EventVisibility } from 'src/app/module/events/models/event-visibility';

interface EventData {
  id: string;
  image: string;
  name: string;
  day?: string;
  month?: string;
  city?: string;
  state?: string;
  local: string;
  localUrl?: string;
  visibility?: EventVisibility;
}

@Component({
  selector: 'app-card-carousel',
  templateUrl: './card-carousel.component.html',
  styleUrls: ['./card-carousel.component.scss'],
  imports: [
    CarouselModule,
    CardEventComponent
],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardCarouselComponent {
  section = input.required<string>();
  events = input<EventData[]>([]);
  numVisible = input<number>(1);
  numScroll = input<number>(1);

  readonly MONTH_FORMAT: Record<number, string> = {
    0: 'JAN',
    1: 'FEV',
    2: 'MAR',
    3: 'ABR',
    4: 'MAI',
    5: 'JUN',
    6: 'JUL',
    7: 'AGO',
    8: 'SET',
    9: 'OUT',
    10: 'NOV',
    11: 'DEZ',
  };

  /**
   * Reduz a quantidade de cards conforme a largura da tela, sem nunca exceder
   * o valor base pedido pelo chamador (numVisible/numScroll).
   */
  responsiveOptions = computed(() => {
    const atMost = (max: number) => {
      const visible = Math.max(1, Math.min(this.numVisible(), max));
      return {
        numVisible: visible,
        numScroll: Math.max(1, Math.min(this.numScroll(), visible)),
      };
    };

    return [
      { breakpoint: '1400px', ...atMost(4) },
      { breakpoint: '1200px', ...atMost(3) },
      { breakpoint: '992px', ...atMost(2) },
      { breakpoint: '768px', ...atMost(2) },
      { breakpoint: '576px', ...atMost(1) },
    ];
  });

  parseMonth(month: string): number {
    return Number(month);
  }
}
